import {
  Button,
  Input,
  Select,
  Space,
  Switch,
  TableProps,
  Tooltip,
} from "antd";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../../app/store";
import AddIcon from "../../../assets/icons/AddIcon";
import EditIcon from "../../../assets/icons/EditIcon";
import SearchIcon from "../../../assets/icons/SearchIcon";
import SelectDownIcon from "../../../assets/icons/SelectDownIcon";
import ViewIcon from "../../../assets/icons/ViewIcon";
import CustomTable from "../../../components/ui/CustomTable";
import Loader from "../../../components/ui/Loader";
import {
  useGetProtalAllSubDepartmentQuery,
  useUpdatePortalStatusSubDepartmentMutation,
} from "../../../features/portal/settings/settingsApi";
import useError from "../../../hooks/useError";
import useModal from "../../../hooks/useModal";
import useTable from "../../../hooks/useTable";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { formatDate } from "../../../lib/time";
import { toast } from "../../../lib/toast";
import {
  GetProtalAllSubDepartmentDataType,
  GetProtalAllSubDepartmentParamsType,
} from "../../../types/portal/settings";
import { countParPageSerialNumber } from "../../../utils/number";
import { addKeyInArray, selectSearchOption } from "../../../utils/utils";
import ManageDesignation from "./_components/ManageDesignation";

enum DesignationStatus {
  "Inactive",
  "Active",
}

export default function SubDepartmentList() {
  const [isViewOpen, setIsViewOpen] = useState(false);
  const {
    page,
    limit,
    handlePagination,
    handleFilter,
    handleLimit,
    filter,
    keyword,
    handleSearch,
  } = useTable<GetProtalAllSubDepartmentParamsType>();
  const { open, handleOpen, handleClose } = useModal<string, any>();
  const { user } = useAppSelector((state) => state.auth);

  const [
    updatePortalStatusSubDepartment,
    {
      isSuccess: isStatusSuccess,
      isLoading: isStatusLoading,
      isError: isStatusError,
      error: statusError,
    },
  ] = useUpdatePortalStatusSubDepartmentMutation();
  useError(isStatusError, statusError, "Designation status update failed");

  const { data, isError, error, isLoading } = useGetProtalAllSubDepartmentQuery(
    {
      params: {
        status:
          filter.status === 1 ? true : filter.status === 0 ? false : undefined,
        skip: undefined,
        page,
        limit,
        search: keyword,
        company_id: user?.data?.company_id,
      },
    }
  );
  useError(isError, error, "Get all sub department data failed");

  const columns: TableProps<
    GetProtalAllSubDepartmentDataType["data"]["data"][0]
  >["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },
    {
      title: "Designation Name",
      dataIndex: "name",
      render: (val) => (val ? val : "N/A"),
    },
    {
      title: "Department Name",
      dataIndex: "department",
      render: (val) => (val?.name ? val?.name : "N/A"),
    },
    // {
    //   title: "Parent Company",
    //   dataIndex: "parent_company",
    //   render: (val: string) => (val ? val : "N/A"),
    // },
    // {
    //   title: "Head of Department",
    //   dataIndex: "head_of_department",
    //   render: (val: string) => (val ? val : "N/A"),
    // },
    {
      title: "Total Employees",
      dataIndex: "employee_count",
      align: "center",
      render: (val) => (val ? val : "0"),
    },
    {
      title: "Created at",
      dataIndex: "created_at",
      align: "center",
      render: (val) => (val ? formatDate(val) : "N/A"),
    },

    {
      title: "Status",
      dataIndex: "status",
      render: (val, record) => (
        <Space size={4}>
          <Switch
            className="custom-switch"
            checked={val}
            onChange={(checked) =>
              updatePortalStatusSubDepartment({
                data: {
                  status: checked ? true : false,
                },
                id: record?.id,
              })
            }
            disabled={isStatusLoading}
          />
          <span className="text-header text-sm font-medium">
            {DesignationStatus[val ? 1 : 0]}
          </span>
        </Space>
      ),
    },
    {
      title: "Actions",
      align: "center",
      render: (record: any) => (
        <div className="flex justify-center items-center gap-2">
          <Tooltip title="Edit Designation">
            <Button
              className="action-button"
              size="small"
              icon={<EditIcon />}
              onClick={() => {
                handleOpen({
                  type: "UPDATE",
                  data: record,
                });
              }}
            />
          </Tooltip>{" "}
          <Tooltip title="View Designation">
            <Button
              className="action-button"
              size="small"
              icon={<ViewIcon />}
              onClick={() => {
                handleOpen({
                  type: "VIEW",
                  data: record,
                });
                setIsViewOpen(true);
              }}
            />
          </Tooltip>
          {/* <Tooltip title="Edit Status">
            <Button
              className="action-button"
              size="small"
              icon={<RefreshIcon />}
              onClick={() =>
                handleProductActivityOpen({
                  type: "PRODUCT_ACTIVITY",
                  data: record,
                })
              }
            />
          </Tooltip> */}
        </div>
      ),
    },
  ];

  const handleCloseView = () => {
    setIsViewOpen(false);
    handleClose();
  };

  useEffect(() => {
    if (isStatusSuccess) {
      toast("success", "Status updated successfully");
      handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isStatusSuccess]);

  return (
    <>
      {(open?.type === "ADD" ||
        open?.type === "UPDATE" ||
        open?.type === "VIEW") && (
        <ManageDesignation
          open={open?.open}
          data={open?.data}
          type={open?.type}
          handleClose={handleCloseView}
        />
      )}

      {/* {productActivityOpen?.type === "PRODUCT_ACTIVITY" && (
        <SubDepartmentStatusUpdateModal
          title=""
          subTitle=""
          buttonName="Send"
          open={productActivityOpen?.open}
          data={productActivityOpen?.data}
          handleClose={handleProductActivityClose}
          action
          buttonBgDeep
          loading={isLoading}
        />
      )} */}

      <SidebarLayout title="Designation List">
        {isLoading ? (
          <Loader />
        ) : (
          <CustomTable
            loading={false}
            limit={limit}
            page={page}
            columns={columns}
            total={data?.data?.total || 0}
            dataSource={addKeyInArray(data?.data?.data)}
            handleLimit={handleLimit}
            handlePagination={handlePagination}
            filterSection={
              <>
                <Input
                  suffix={<SearchIcon />}
                  placeholder="Search by designation name"
                  style={{ width: 300 }}
                  allowClear
                  onChange={handleSearch}
                />

                <Select
                  allowClear
                  showSearch
                  placeholder="Status"
                  filterOption={selectSearchOption}
                  options={[
                    { label: "Active", value: "active" },
                    { label: "Inactive", value: "inactive" },
                  ]}
                  onChange={(value) => {
                    handleFilter(
                      "status",
                      value === "active"
                        ? 1
                        : value === "inactive"
                        ? 0
                        : undefined
                    );
                  }}
                  className="min-w-[90px]"
                  suffixIcon={<SelectDownIcon />}
                  rootClassName="icon-gray"
                />

                <Button
                  type="primary"
                  className="middle-button"
                  icon={<AddIcon />}
                  onClick={() =>
                    handleOpen({
                      type: "ADD",
                    })
                  }
                >
                  Add Designation
                </Button>
              </>
            }
          />
        )}
      </SidebarLayout>
    </>
  );
}
